angular.module('TetherApp').factory('campaignService', [
    '$http',
    function($http) {
        let randomString = function randomString(length, chars) {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let list = function (encrypt) {
            let uri = '/api/v1/campaign/' + randomString(
                16,
                '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
            );
            return $http.get(uri, {
                cache: false,
                headers: { 'Cache-Control' : 'no-cache' },
                params: { encrypt: encrypt }
            }).then(function (response) {
                return response.data;
            });
        };

        let graph = function (clientEid, campaignEid, parameters) {
            return $http.get('/' + clientEid + '/api/campaign-graph/' + campaignEid, {
                cache: false,
                headers: { 'Cache-Control' : 'no-cache' },
                params: parameters
            }).then(function (response) {
                return response.data;
            });
        };

        let stats = function (clientEid, campaignEid, parameters) {
            return $http.get('/' + clientEid + '/api/campaign-stats/' + campaignEid, {
                cache: false,
                headers: { 'Cache-Control' : 'no-cache' },
                params: parameters
            }).then(function (response) {
                return response.data;
            });
        };

        return {
            list: list,
            graph: graph,
            stats: stats
        }
    }
]);
